import React, { useEffect } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { AuthContext, SidebarProvider } from './contexts'
import AppRoutes from './routes'
import theme from './theme'
import 'react-perfect-scrollbar/dist/css/styles.css'
import { SnackbarProvider } from './components/SnackbarProvider'

const App = () => {
  useEffect(() => {
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName)
        })
      })
    }
  }, [])

  return (
    <SnackbarProvider>
      <ThemeProvider theme={theme}>
        <AuthContext>
          <CssBaseline />
          <SidebarProvider>
            <AppRoutes />
          </SidebarProvider>
        </AuthContext>
      </ThemeProvider>
    </SnackbarProvider>
  )
}
export default App
